<script>
export let emailRecuperar="";
export let senha="";
export let statusRecuperarSenha=0;
export let abrirModal=false;
export let fimCompRecuperarSenha=false;
export let inicioCompRecuperarSenha=false;
import {onMount, createEventDispatcher } from 'svelte';
import {Button,
    ButtonGroup,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader} from 'sveltestrap';
const dispatch = createEventDispatcher();
onMount(()=>{abrirModal=false;}); 
function Recuperar(e){
    e.preventDefault();
	dispatch("Recuperar");
}


function Finaliza(){
     	abrirModal=false;
		dispatch("ChamarTela","login")
		
}

</script>

<section>
<body class='back'>

<div class=" container ">
	<div class="d-flex justify-content-center h-100 ">
		<div class="card ">
			<div class="card-header">
				<h3>Recuperar senha</h3>
				
			</div>
			<div class="card-body">
				<form >
					<div class="input-group form-group">
						<div class="input-group-prepend">
							
						</div>
                        
						<input type="text" class="form-control" placeholder="Digite seu email" bind:value={emailRecuperar}>
						
					</div>
					
					<div class="row align-items-center remember">
                    {#if statusRecuperarSenha==2}
                    <span  class="tabular">Email não cadastrado</span>
					{:else if statusRecuperarSenha==3}
                    <span  class="tabular">Erro</span>
					{:else if statusRecuperarSenha==4}
                    <span  class="tabular">Erro de comunicação</span>
                    {/if}
						<!--<input type="checkbox">Lembrar me-->
					</div>
					<div class="form-group">
                    
					    {#if  emailRecuperar!=""}
                        
                  
                        <input type="submit" on:click={(e)=>Recuperar(e)} value="Enviar"  class="btn float-right login_btn">
						{/if}
                        <button   value="Voltar" class="btn float-right login_btn tabular-direita">Voltar</button>
                       
					</div>
				</form>


                           <Modal isOpen={abrirModal} class="modal-body">
                            <ModalHeader {abrirModal}>Sucesso</ModalHeader>
                                <ModalBody>
                                Um email com orientações de recuperação de senha foi enviado para {emailRecuperar}
                                
                                </ModalBody>
                                <ModalFooter>
                                
                                
                                <Button color="primary" on:click={(e)=>Finaliza(e)}>
                                    Ok  
                                </Button> 
                                </ModalFooter>           </Modal> 


			</div>
			
			
		</div>
	</div>
</div>


</body>

</section>
<style>
/* Bordered form */
/* Made with love by Mutiullah Samim*/

@import url('https://fonts.googleapis.com/css?family=Numans');
body{
    
    background-color: black}
.back{
background-image: url('/img/back.jpg');
background-size: cover;
background-repeat: no-repeat;

height: 100%;
padding: 10px;
font-family: 'Numans', sans-serif;

}

.container{
height: 100%;
align-content: center;
}

.card{
height: 230px;
margin-top:100px;
margin-bottom: 300px;
width: 400px;
background-color: rgba(0,0,0,0.5) !important;
}

.social_icon span{
font-size: 60px;
margin-left: 10px;
color: #FFC312;
}

.social_icon span:hover{
color: white;
cursor: pointer;
}

.card-header h3{
color: white;
}

.social_icon{
position: absolute;
right: 20px;
top: -45px;
}

.input-group-prepend span{
width: 50px;
background-color: #FFC312;
color: black;
border:0 !important;
}

input:focus{
outline: 0 0 0 0  !important;
box-shadow: 0 0 0 0 !important;

}

.remember{
color: white;
}

.remember input
{
width: 20px;
height: 20px;
margin-left: 15px;
margin-right: 5px;
}

.login_btn{
color: black;
background-color: #FFC312;
width: 100px;
}

.login_btn:hover{
color: black;
background-color: white;
}

.links{
color: white;
}
.links a{
margin-left: 4px;
}
.tabular{
	margin-left:  20px;
}
.tabular-direita{
	margin-right:  20px;
}
</style>